/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface UserModelResponse
 */
export interface UserModelResponse {
    /**
     *
     * @type {string}
     * @memberof UserModelResponse
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof UserModelResponse
     */
    name: string;
    /**
     *
     * @type {string}
     * @memberof UserModelResponse
     */
    email: string;
    /**
     *
     * @type {boolean}
     * @memberof UserModelResponse
     */
    activated: boolean;
}

/**
 * Check if a given object implements the UserModelResponse interface.
 */
export function instanceOfUserModelResponse(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    if (!('email' in value)) return false;
    if (!('activated' in value)) return false;
    return true;
}

export function UserModelResponseFromJSON(json: any): UserModelResponse {
    return UserModelResponseFromJSONTyped(json, false);
}

export function UserModelResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UserModelResponse {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        name: json['name'],
        email: json['email'],
        activated: json['activated'],
    };
}

export function UserModelResponseToJSON(value?: UserModelResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        name: value['name'],
        email: value['email'],
        activated: value['activated'],
    };
}
